import React from 'react';

const TaskRouter = () => {
  return (
    <div className="task-router-wrapper" style={{ width: '100%', height: 'calc(100vh - 2rem)', minHeight: 600 }}>
      <iframe
        src="/task-router-prototype.html"
        title="Task Router — Lockton"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
    </div>
  );
};

export default TaskRouter;
